import rawGameLogs from "./playerGameLogs.json";
import type { Position } from "../models/Player";

export type PlayerGameLogRow = {
  week: number;
  opponent: string;
  projection?: number;
  fantasyPoints?: number;
  fantasyPointsStandard?: number;
  fantasyPointsHalfPpr?: number;
  fantasyPointsPpr?: number;
  snapPct?: number;
  passingAttempts?: number;
  passingCompletions?: number;
  passingYards?: number;
  passingTds?: number;
  passingInterceptions?: number;
  rushAttempts?: number;
  rushYards?: number;
  rushTds?: number;
  sacks?: number;
  sackYardsLost?: number;
  targets?: number;
  receptions?: number;
  receivingYards?: number;
  receivingTds?: number;
  fumbles?: number;
  fumblesLost?: number;
  kickoffReturns?: number;
  kickoffReturnYards?: number;
  puntReturns?: number;
  specialTeamsTds?: number;
  note?: string;
};

export type PlayerSeasonGameLogs = {
  season: number;
  rows: PlayerGameLogRow[];
};

export type PlayerGameLogsIndex = Record<string, PlayerSeasonGameLogs[]>;
export type PlayerGameLogPosition = Extract<Position, "QB" | "RB" | "WR" | "TE">;
export type PlayerGameLogScoring = "standard" | "halfPpr" | "ppr";
const REGULAR_SEASON_FINAL_WEEK = 18;

function filterRegularSeasonLogs(index: PlayerGameLogsIndex): PlayerGameLogsIndex {
  return Object.fromEntries(
    Object.entries(index).map(([playerId, seasons]) => [
      playerId,
      seasons.map((season) => ({
        ...season,
        rows: season.rows.filter((row) => row.week <= REGULAR_SEASON_FINAL_WEEK),
      })),
    ])
  );
}

const playerGameLogs: PlayerGameLogsIndex = filterRegularSeasonLogs(
  ((rawGameLogs as unknown as PlayerGameLogsIndex) ?? {})
);

export const playerGameLogsById: PlayerGameLogsIndex = playerGameLogs;

export function getPlayerGameLogs(playerId: string): PlayerSeasonGameLogs[] {
  return playerGameLogs[playerId] ?? [];
}

export default playerGameLogs;
